<template>
  <!-- BEGIN: Main Menu-->
  <div class="main-menu menu-fixed menu-light menu-accordion menu-shadow" data-scroll-to-active="true">
    <div class="navbar-header">
      <ul class="nav navbar-nav flex-row">
        <li class="nav-item mr-auto"><a class="navbar-brand" href="javascript:void(0)" @click="$router.push({name : 'dashboard-overview'})">
          <span class="brand-logo">
            <img v-show="hideBar"  :src="`${publicPath}images/vaults-authlogo.png`">
          </span>
          <h2 v-show="!hideBar" class="brand-text"><img width="150"   :src="`${publicPath}app-assets/logo/vaults_logo.png`"></h2>
        </a></li>
        <li @click="hideBar = !hideBar" class="nav-item nav-toggle"><a class="nav-link modern-nav-toggle pr-0" data-toggle="collapse"><i
            class="d-block d-xl-none text-primary toggle-icon font-medium-4" data-feather="x"></i><i
            class="d-none d-xl-block collapse-toggle-icon font-medium-4  text-primary" data-feather="disc"
            data-ticon="disc"></i></a></li>
      </ul>
    </div>
    <div class="shadow-bottom"></div>
    <div class="main-menu-content">
      <ul class="navigation navigation-main mt-2" id="main-menu-navigation" data-menu="menu-navigation">
<!--        <li class=" nav-item"><a class="d-flex align-items-center" href="javascript:void(0)" @click="route('index')">-->
<!--          <BIconHouseDoor class="text-dark" />-->
<!--          <span-->
<!--            class="menu-title text-truncate" data-i18n="Dashboards">Dashboards</span></a>-->
<!--        </li>-->
        <template v-for="(featureItem, featureIndex) in featureList" :key="featureIndex">
          <li class=" navigation-header"><span>{{ featureItem.name }}</span><i
              data-feather="more-horizontal"></i>
          </li>
          <li class="nav-item" :class="feature.slug== currentRoute ? 'active' : ''" v-for="(feature, index) in featureItem.features" :key="index">
            <!-- <a class="d-flex align-items-center" href="javascript:void(0)" @click="route(feature.slug)">
              <BIconJournalText v-if="feature.web_icon == null"  />
              <img v-else :src="feature.web_icon" width="24" height="24" style="margin-right: 1.1rem">
              <span class="menu-title text-truncate" data-i18n="Email">{{ feature.name }}</span>
            </a> -->


            <router-link v-if="$router.hasRoute(feature.slug)" class="d-flex align-items-center" :to="{name:feature.slug}">
              <BIconJournalText v-if="feature.web_icon == null"  />
              <img v-else :src="feature.web_icon" width="24" height="24" style="margin-right: 1.1rem">
              <span class="menu-title text-truncate" data-i18n="Email">{{ feature.name }}</span>

              </router-link>

          </li>
        </template>

      </ul>
    </div>
  </div>
  <!-- END: Main Menu-->
</template>

<script>

export default {
  mounted() {
    this.currentRoute = this.$route.name
    setTimeout(() => {
      this.featureList = this.$store.getters.getDashboardFeatures
      if(!this.featureList){
        this.sendCall()
      }
    }, 500);
    // this.sendCall()

  },
  data() {
    return {
      loader: false,
      featureList: [],
      hideBar:false,
      currentRoute : ''
    }
  },
  methods: {
    route(slug = 'currency') {
      document.querySelector("#noti-dropdown-li").classList.remove("show");
      document.querySelector("#noti-dropdown-ul").classList.remove("show");
      this.$router.push({name: slug});
    },
    sendCall() {
      this.makeRequest('post', 'v1/get-dashboard-feature-list', {}, {}, false,false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.featureList = callResponse.response.data.data
          }
        }

      });

    },
  },
  watch:{
    $route (to, from){
      this.currentRoute = to.name
    }
  }
}
</script>

